export const ViewDashboard = 1;
export const ViewSettings = 2;
export const ManageSubscriptions = 4;
export const ViewSubscriptionUsage = 5;
export const ViewVideoAnalysisUsage = 6;

export const ViewSewerObjects = 100;
export const UploadSewerObjects = 103;
export const DeleteSewerObject = 104;
export const ViewSewerObject = 105;
export const EditSewerObject = 106;
export const EditSewerObjectFromAssignedProject = 107;
export const DeleteSewerObjectsFromAssignedProject = 108;
export const AssignUserToProject = 112;
export const RemoveUserFromProject = 113;
export const ViewProjectTeamMembers = 114;
export const ExportSewerObjects = 115;
export const UploadSewerObjectsToProjectAssignedTo = 116;
export const ExportSewerObjectsFromAssignedProject = 117;
export const ViewLinkedSewerObjects = 118;
export const ViewLinkedSewerObjectsFromAssignedProject = 119;

export const ViewInspectionsList = 200;
export const CreateInspection = 201;
export const DeleteInspection = 202;
export const EditInspection = 203;
export const EditInspectionFromAssignedProject = 204;
export const DeleteInspectionFromAssignedProject = 205;
export const DeleteInspectionFiles = 209;
export const ViewInspection = 210;
export const DownloadInspectionFiles = 211;
export const ViewInspectionReport = 213;
export const RunVideoAnalysis = 214;
export const RunVideoConversion = 216;
export const DownloadInspectionFilesFromAssignedProject = 217;
export const DeleteInspectionFilesFromAssignedProject = 218;
export const RunVideoAnalysisFromAssignedProject = 219;
export const RunVideoConversionFromAssignedProject = 220;
export const ViewInspectionReportFromAssignedProject = 221;
export const DownloadInspectionReport = 212;
export const DownloadInspectionReportFromAssignedProject = 223;

export const ViewDamagesList = 400;
export const ViewDamage = 401;
export const DeleteDamage = 402;
export const EditDamage = 403;
export const CreateDamage = 404;
export const ViewDamagesFromAssignedProject = 405;
export const ViewDamageFromAssignedProject = 406;
export const CreateDamageInAssignedProject = 408;
export const EditDamageFromAssignedProject = 409;
export const DeleteDamageFromAssignedProject = 410;

export const CreateJob = 500;
export const ViewJob = 501;
export const EditJob = 502;
export const DeleteJob = 503;
export const TakeJob = 504;
export const EditAssignedJob = 505;
export const AssignSewerObjectsToJob = 506;
export const ChangeJobStatus = 507;
export const ChangeJobPriority = 508;
export const AssignJobToUser = 509;
export const AddJobToProject = 510;
export const ViewJobsList = 511;
export const RemoveSewerObjectsFromJob = 512;
export const AssignAnyProjectAndUserToJob = 515;
export const TakeJobFromAssignedProject = 516;
export const ChangeJobStatusFromAssignedProject = 517;
export const DeleteAssignedJob = 518;
export const AssignSewerObjectsToAssignedJob = 519;
export const RemoveSewerObjectsFromAssignedJob = 520;
export const ViewSewerObjectsLinkedToJob = 521;
export const ViewSewerObjectsLinkedToAssignedJobOrJobProject = 522;

export const ViewUsersList = 600;
export const AddUserToOrganization = 601;
export const RemoveUser = 602;
export const ViewUser = 603;
export const EditUser = 604;
export const ViewRemovedUsers = 606;
export const ManageDeletedData = 607;

export const AssignUserRole = 700;
export const AssignEmploymentStatus = 702;

export const CreateProject = 800;
export const ViewProject = 801;
export const EditProject = 802;
export const DeleteProject = 803;
export const ViewProjectList = 804;
export const ViewProjectAssignedTo = 806;
export const ViewProjectsAssignedTo = 807;
export const ViewSewerObjectFromAssignedProject = 808;
export const ViewSewerObjectsFromAssignedProject = 809;
export const ViewJobFromAssignedProject = 810;
export const ViewJobsFromAssignedProject = 811;
export const ViewTeamMembersFromAssignedProject = 812;
export const ViewInpsectionsFromAssignedProject = 814;
export const ViewInspectionFromAssignedProject = 815;
export const EditProjectAssignedTo = 817;
export const EditProjectLead = 818;
export const DeleteProjectIfLead = 819;

export const ViewOrganizationInfo = 900;
export const EditOrganizationInfo = 901;
export const ViewOrganizationGisCoordinates = 902;
export const EditOrganizationGisCoordinates = 903;
export const ViewOrganizationProjectProperties = 904;
export const AddOrganizationProjectProperties = 905;
export const ViewOrganizationAnalysisConfidence = 912;
export const EditOrganizationAnalysisConfidence = 913;
export const AccessOrganization = 909;

export const ManageReportTemplates = 1000;
